import { validateRulebook } from "@next-platform/packages-ts-types";
import { useEffect, useMemo, useState } from "react";
import groupRulebookIssues, {} from "./groupRulebookIssues";
import { collectRulebookDraftCompletenessIssues, withRulebookDraftCompleteness } from "./validateRulebookDraft";
/**
 * Structural `validateRulebook` is debounced (first result computed synchronously so the initial render has output);
 * editor completeness checks (name, description, tags, cover, meters) are recomputed on every render so the Save gate
 * closes the moment a required field goes missing.
 */
export default function useRulebookValidation({ definition, meta, debounceMs = 150, }) {
    const [stateStructural, setStateStructural] = useState(() => validateRulebook(definition));
    useEffect(() => {
        const timer = setTimeout(() => {
            setStateStructural(validateRulebook(definition));
        }, debounceMs);
        return () => clearTimeout(timer);
    }, [definition, debounceMs]);
    const validation = useMemo(() => withRulebookDraftCompleteness({
        structural: stateStructural,
        completeness: collectRulebookDraftCompletenessIssues({ definition, meta }),
    }), [stateStructural, definition, meta]);
    const grouped = useMemo(() => groupRulebookIssues(validation.issues), [validation]);
    return { validation, structural: stateStructural, grouped };
}
